import pImg1 from '../images/portfolio/portfolio_details_image_1.jpg'
import pImg2 from '../images/portfolio/portfolio_details_image_2.png'
import pImg3 from '../images/portfolio/portfolio_details_image_3.jpg'
import pImg4 from '../images/portfolio/portfolio_details_image_4.jpg'
import pImg5 from '../images/portfolio/portfolio_details_image_5.jpg'


const Project = [
    {
        Id: '1',
        pImg: pImg1,
        title: 'Silverbird Cinemas — Accra Mall',
        slug: 'silverbird-accra-mall-fire-sprinkler',
        sub: 'Fire sprinkler installation',
        description: 'Nov 2015 — Supply and installation of a comprehensive fire‑sprinkler system for Silverbird Cinemas at Accra Mall. Contact: Prince Essah',
    },
    {
        Id: '2',
        pImg: pImg2,
        title: 'Bank of Africa — Datacenter Protection',
        slug: 'bank-of-africa-datacenter-protection',
        sub: 'FM‑200 suppression & environmental monitoring',
        description: 'May 2015 — Installation of FM‑200 fire suppression and datacenter environmental monitoring to protect critical banking infrastructure. Contact: Mr. Raymond',
    },
    {
        Id: '3',
        pImg: pImg3,
        title: 'University of Ghana — Balme Library',
        slug: 'university-of-ghana-balme-library-cctv',
        sub: 'CCTV & LAN',
        description: 'Nov 2013 — Supply and installation of network cameras and LAN for the Balme Library to enhance campus security and connectivity. Contact: Mr. Baafe Adomako',
    },
    {
        Id: '4',
        pImg: pImg4,
        title: 'University of Cape Coast — ICT Centre',
        slug: 'university-of-cape-coast-ict-center',
        sub: 'Computers, printers & LAN',
        description: 'Apr 2013 — Supply and installation of computers, printers and LAN implementation for the ICT Centre. Contact: Mrs. Harriet Menu',
    },
    {
        Id: '5',
        pImg: pImg5,
        title: 'Ghana Revenue Authority — Datacenter Projects',
        slug: 'ghana-revenue-authority-datacenter',
        sub: 'Integrated datacenter solutions',
        description: '2016–2017 — FM‑200 suppression, access control and datacenter buildouts for Accra and Kumasi (including SLA & ongoing maintenance). Contact: Mr. Geffrey Asiadu',
    }
]

export default Project;